import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibFlagFillIcon } from '@chewy/kib-icons-react'
import KibLabel from '@chewy/kib-label-react'

import '@chewy/kib-label-styles/dist/kib-label.css'

export interface ControlledSubstanceChipProps {
  className?: string
}

export const ControlledSubstanceChip = ({
  className,
}: ControlledSubstanceChipProps) => {
  const { t } = useTranslation(['Common'])

  return (
    <KibLabel className={className} variant="danger">
      <KibFlagFillIcon style={{ width: '1em', height: '1em' }} />{' '}
      {t('Common:CONTROLLED_SUBSTANCE')}
    </KibLabel>
  )
}

export default ControlledSubstanceChip
